var map = {
	"./header-lightbox-forest.jpg": "HRhn",
	"./header-lightbox-ocean.jpg": "jwxb"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "juPZ";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/header\-lightbox\-.*\.jpg$
// module id = juPZ
// module chunks = 1